<script>

import {breakpoint, platform} from './MediaQuery.svelte'

//$: console.log($breakpoint)
//$: if($breakpoint) console.log('cambio ',$breakpoint)

</script>

<div class="p-2 position-absolute bottom-0 end-0 bg-danger text-white">
  {#if $breakpoint == 'xs'}XS{/if}
  {#if $breakpoint == 'sm'}SM{/if}
  {#if $breakpoint == 'md'}MD{/if}
  {#if $breakpoint == 'lg'}LG{/if}
  {#if $breakpoint == 'xl'}XL{/if}
  {#if $breakpoint == 'xxl'}XXL{/if}
</div>